import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { About } from './components/About';
import { Services } from './components/Services';
import { Qualify } from './components/Qualify';
import { Testimonials } from './components/Testimonials';
import { SignUpForm } from './components/SignUpForm';
import { PressStrip } from './components/PressStrip';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen flex flex-col" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <TrustStrip data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <Qualify data-id="element-7" />
        <Testimonials data-id="element-8" />
        <SignUpForm data-id="element-9" />
        <PressStrip data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}